import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateSalaryHistory,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data(select_data);
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = () => {
    const token = localStorage.getItem("token");

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async ({ isConfirmed }) => {
      if (!isConfirmed) {
        Swal.fire("Changes are not saved", "", "info");
        return;
      }

      try {
        const {
          _id,
          actual_pay,
          actual_salary,
          actual_working_days,
          comments,
          routeabsentism,
          recoverablecod,
          philfridge,
        } = update_modal_data;

        if (!_id) {
          throw new Error("ID is not defined");
        }

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        // Step 1: Update existing salary adjustment fields and comments
        const requestBody = {
          actual_working_days: Number(actual_working_days) || 0,
          actual_pay: Number(actual_pay) || 0,
          actual_salary: Number(actual_salary) || 0,
          commentText: comments || "",
        };

        const res = await axios.patch(
          `${process.env.REACT_APP_BASE_URL}/api/v4/salary-history/salary-history/${_id}/adjust`,
          requestBody,
          { headers },
        );

        if (!res.data.success) {
          Swal.fire(
            "Update failed",
            "Could not update salary details.",
            "error",
          );
          return;
        }

        // Step 2: Save the three manual deduction fields
        const deductionResponse = await axios.patch(
          `${process.env.REACT_APP_BASE_URL}/api/v4/salary-history/salary-history/${_id}`,
          {
            routeabsentism: Number(routeabsentism) || 0,
            recoverablecod: Number(recoverablecod) || 0,
            philfridge: Number(philfridge) || 0,
          },
          { headers },
        );

        if (!deductionResponse.data.success) {
          Swal.fire(
            "Partial update",
            "Salary details were updated, but the new deductions could not be saved. Please retry.",
            "warning",
          );
          return;
        }

        // Use the latest record returned by the deductions API
        const updatedData = deductionResponse.data.data;

        Swal.fire(
          "Update success",
          "Salary details and deductions updated.",
          "success",
        );

        onUpdateSalaryHistory?.(updatedData);
        setUpdate_modal_data(updatedData);
        set_update_data_modal_Show(false);
        setRen((prev) => !prev);
      } catch (error) {
        Swal.fire("Update failed", "Unable to save salary details.", "error");

        if (error.response) {
          console.error("Server error:", error.response.data);
        } else if (error.request) {
          console.error("No response:", error.request);
        } else {
          console.error("Request setup error:", error.message);
        }
      }
    });
  };

  return (
    <Modal show={add_data_modal_Show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Salary History Data</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Route Absentism</Form.Label>
            <Form.Control
              type="number"
              name="routeabsentism"
              min="0"
              step="0.01"
              value={update_modal_data.routeabsentism ?? 0}
              onChange={handleChange}
              placeholder="Enter route absentism deduction"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Recoverable COD</Form.Label>
            <Form.Control
              type="number"
              name="recoverablecod"
              min="0"
              step="0.01"
              value={update_modal_data.recoverablecod ?? 0}
              onChange={handleChange}
              placeholder="Enter recoverable COD deduction"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Pilferage</Form.Label>
            <Form.Control
              type="number"
              name="Pilferage"
              min="0"
              step="0.01"
              value={update_modal_data.philfridge ?? 0}
              onChange={handleChange}
              placeholder="Enter Pilferage deduction"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Final Salary</Form.Label>
            <Form.Control
              type="number"
              name="actual_salary"
              value={update_modal_data.actual_salary || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Paid Amount</Form.Label>
            <Form.Control
              type="number"
              name="actual_pay"
              value={update_modal_data.actual_pay || ""}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Actual Working Days</Form.Label>
            <Form.Control
              type="number"
              name="actual_working_days"
              value={update_modal_data.actual_working_days || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Comments *</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="comments"
              value={
                Array.isArray(update_modal_data.comments)
                  ? update_modal_data.comments.map((c) => c.text).join("\n")
                  : update_modal_data.comments || ""
              }
              onChange={handleChange}
              placeholder="Enter comments"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" className="btn btn-sm" onClick={handleUpdate}>
          Update Salary History
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
